export const ethiopianSongs = [
  {
    id: 1,
    title: "Tizita",
    artist: "Mulatu Astatke",
    album: "Ethiopiques, Vol. 4",
    year: 1969,
    genre: "Ethio-Jazz",
    language: "Amharic",
    duration: "4:32",
    country: "Ethiopia",
    popularity: 95,
    spotifyId: "ethiopian_001"
  },
  {
    id: 2,
    title: "Yekermo Sew",
    artist: "Mulatu Astatke",
    album: "Ethiopiques, Vol. 4",
    year: 1972,
    genre: "Ethio-Jazz",
    language: "Amharic",
    duration: "3:45",
    country: "Ethiopia",
    popularity: 92,
    spotifyId: "ethiopian_002"
  },
  {
    id: 3,
    title: "Tezeta",
    artist: "Alemayehu Eshete",
    album: "Ethiopiques, Vol. 9",
    year: 1973,
    genre: "Ethio-Pop",
    language: "Amharic",
    duration: "3:18",
    country: "Ethiopia",
    popularity: 88,
    spotifyId: "ethiopian_003"
  },
  {
    id: 4,
    title: "Ene Yewedajo",
    artist: "Tilahun Gessesse",
    album: "Ethiopiques, Vol. 17",
    year: 1974,
    genre: "Ethio-Pop",
    language: "Amharic",
    duration: "4:15",
    country: "Ethiopia",
    popularity: 90,
    spotifyId: "ethiopian_004"
  },
  {
    id: 5,
    title: "Muziqawi Silt",
    artist: "Wallias Band",
    album: "Ethiopiques, Vol. 16",
    year: 1977,
    genre: "Ethio-Funk",
    language: "Amharic",
    duration: "5:22",
    country: "Ethiopia",
    popularity: 85,
    spotifyId: "ethiopian_005"
  },
  {
    id: 6,
    title: "Yegelle Tezeta",
    artist: "Girma Beyene",
    album: "Ethiopiques, Vol. 8",
    year: 1970,
    genre: "Ethio-Jazz",
    language: "Amharic",
    duration: "3:55",
    country: "Ethiopia",
    popularity: 87,
    spotifyId: "ethiopian_006"
  },
  {
    id: 7,
    title: "Almaz",
    artist: "Aster Aweke",
    album: "Aster",
    year: 1989,
    genre: "Ethio-Pop",
    language: "Amharic",
    duration: "4:08",
    country: "Ethiopia",
    popularity: 93,
    spotifyId: "ethiopian_007"
  },
  {
    id: 8,
    title: "Yene Habesha",
    artist: "Teddy Afro",
    album: "Yasteseryal",
    year: 2005,
    genre: "Ethio-Pop",
    language: "Amharic",
    duration: "4:45",
    country: "Ethiopia",
    popularity: 96,
    spotifyId: "ethiopian_008"
  },
  {
    id: 9,
    title: "Mar Eske Tuab",
    artist: "Gigi",
    album: "Gigi",
    year: 2001,
    genre: "Ethio-Pop",
    language: "Amharic",
    duration: "3:52",
    country: "Ethiopia",
    popularity: 89,
    spotifyId: "ethiopian_009"
  },
  {
    id: 10,
    title: "Kulun Mankwalesh",
    artist: "Mahmoud Ahmed",
    album: "Ethiopiques, Vol. 7",
    year: 1975,
    genre: "Ethio-Pop",
    language: "Amharic",
    duration: "4:20",
    country: "Ethiopia",
    popularity: 91,
    spotifyId: "ethiopian_010"
  },
  {
    id: 11,
    title: "Dewel",
    artist: "Hailu Mergia",
    album: "Ethiopiques, Vol. 14",
    year: 1978,
    genre: "Ethio-Jazz",
    language: "Amharic",
    duration: "3:38",
    country: "Ethiopia",
    popularity: 84,
    spotifyId: "ethiopian_011"
  },
  {
    id: 12,
    title: "Yekatit",
    artist: "Betty LaVette",
    album: "Ethiopiques, Vol. 21",
    year: 1974,
    genre: "Ethio-Soul",
    language: "Amharic",
    duration: "4:12",
    country: "Ethiopia",
    popularity: 86,
    spotifyId: "ethiopian_012"
  },
  {
    id: 13,
    title: "Mela Mela",
    artist: "Mulatu Astatke",
    album: "Mulatu of Ethiopia",
    year: 1972,
    genre: "Ethio-Jazz",
    language: "Amharic",
    duration: "5:15",
    country: "Ethiopia",
    popularity: 88,
    spotifyId: "ethiopian_013"
  },
  {
    id: 14,
    title: "Yegelle Tezeta",
    artist: "Getatchew Mekurya",
    album: "Ethiopiques, Vol. 14",
    year: 1972,
    genre: "Ethio-Jazz",
    language: "Amharic",
    duration: "4:30",
    country: "Ethiopia",
    popularity: 82,
    spotifyId: "ethiopian_014"
  },
  {
    id: 15,
    title: "Tche Belew",
    artist: "Hailu Mergia",
    album: "Ethiopiques, Vol. 14",
    year: 1978,
    genre: "Ethio-Jazz",
    language: "Amharic",
    duration: "3:45",
    country: "Ethiopia",
    popularity: 83,
    spotifyId: "ethiopian_015"
  }
];

export const ethiopianGenres = [
  "Ethio-Jazz",
  "Ethio-Pop", 
  "Ethio-Funk",
  "Ethio-Soul",
  "Traditional",
  "Modern Ethiopian"
];

export const ethiopianLanguages = [
  "Amharic",
  "Tigrinya", 
  "Oromo",
  "Somali",
  "English"
]; 